export default "__VITE_PUBLIC_ASSET__e626f518__"